<template>
    <div>
      <div class="acr-welcome-message">
            <h3>ویرایش پروفایل کاربری</h3>
        </div>
      <form @submit.prevent="beforeUpdate">
        <div class="row">
            <div class="col-lg-6 form-group">
                <label>نام</label>
                <input v-model="Form_Data.fname" type="text" class="form-control" placeholder="نام" v-validate="{required: true, fa: true}" name="fname">
                <div class="text-danger text-sm" v-for="error in errors.collect('fname')" :key="error">{{ error }}</div>
            </div>
            <div class="col-lg-6 form-group">
                <label>نام خانوادگی</label>
                <input v-model="Form_Data.lname" type="text" class="form-control" placeholder="نام خانوادگی" v-validate="{required: true, fa: true}" name="lname">
                <div class="text-danger text-sm" v-for="error in errors.collect('lname')" :key="error">{{ error }}</div>
            </div>
            <div class="col-lg-6 form-group">
                <label>ایمیل</label>
                <input v-model="Form_Data.email" type="email" class="form-control" placeholder="ایمیل" v-validate="{required: true, email: true}" name="email">
                <div class="text-danger text-sm" v-for="error in errors.collect('email')" :key="error">{{ error }}</div>
            </div>
            <div class="col-lg-6 form-group">
                <label>تلفن همراه</label>
                <input v-model="Form_Data.phone" type="text" class="form-control" placeholder="تلفن همراه" v-validate="{required: true, mobile: true}" name="mobile" :disabled="true">
                <div class="text-danger text-sm" v-for="error in errors.collect('mobile')" :key="error">{{ error }}</div>
            </div>
            <div class="col-lg-6 form-group">
                <label>تاریخ تولد</label>
              <VuePersianDatetimePicker v-model="Form_Data.birth_day"
                                        clearable autoSubmit
                                        format="YYYY-MM-DD HH:mm:ss"
                                        displayFormat="jYYYY-jMM-jDD"
                                        color="#1c2d56"/>
            </div>
        </div>
        <div class="flex items-center justify-center">
            <button @submit.prevent="beforeUpdate" name="submit" class="btn-custom secondary">ذخیره تغییرات</button>
        </div>
        </form>
    </div>
</template>

<script>
import axios from '@/plugins/axios'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
export default {
    props:{
        togglePreLoader: Function
    },
    components: {
        VuePersianDatetimePicker
    },
    data () {
        return {
            Form_Data: {
                fname: JSON.parse(localStorage.getItem('userInfo')).fname ,
                lname: JSON.parse(localStorage.getItem('userInfo')).lname,
                email: JSON.parse(localStorage.getItem('userInfo')).email,
                phone: JSON.parse(localStorage.getItem('userInfo')).phone,
                birth_day: JSON.parse(localStorage.getItem('userInfo')).birth_day,
            },
            Data: null,
            /*Alert: {
                Email: 'وارد کردن  ایمیل الزامی است',
                Phone: 'وارد کردن  تلفن همراه الزامی است'
            },
            Switch: {Phone: false, Email: false},*/
            Notif_Color: 'var(--secondary-color)',
            Notif_Icon: null,
            Notif_Text: null,
            Notif_Title: null
        }
    },
    methods: {
      beforeUpdate(){
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.Update()
            return;
          }

          this.$vs.notify({
            title: 'خطا',
            text: 'اطلاعات خود را به صورت صحیح وارد کنید',
            color: 'danger'})
        });
      },
      async Update () {
        try {
          this.togglePreLoader('open')
          this.Form_Data.name = this.name
          let {data} = await axios ({
            method: 'post',
            url:`/cu/update-profile`,
            headers: {},
            data: this.Form_Data
          })
          this.Data = data
          localStorage.setItem('userInfo',JSON.stringify(data))
          this.$vs.notify({time:3500,text:'اطلاعات با موفقیت به ثبت رسید',icon:'check'})

        }
        catch (error) {
            if (error.response && error.response.data.errors) {
              let str_error = ''
              for(let item of Object.values(error.response.data.errors))
              {
                item.map(xx=>{
                  if (xx.includes("shipping address")){
                    str_error += xx.replace("shipping address","آدرس") + "<br/>"
                  }
                  else{
                    str_error += xx + "<br/>"
                  }
                })
              }
              this.$vs.notify({title:'خطایی رخ داد',time:3500,text:str_error,color:'var(--secondary-color)',icon:'error_outline'})
            }
            else{
              if (error) {
                if(error == "Error: Network Error"){
                  this.$vs.notify({title:'خطایی رخ داد',time:3500,text:"اتصال برقرار نشد",color:'var(--secondary-color)',icon:'error_outline'})
                }
                else {
                  this.$vs.notify({title:'خطایی رخ داد',time:3500,text:error,color:'var(--secondary-color)',icon:'error_outline'})
                }
              }
            }
          } finally {
              this.togglePreLoader('close')
          }
      }
    }
}
</script>

<style>
.vpd-icon-btn{
  margin-bottom: 0;
  border-radius: 0 8px 8px 0;
}
.vpd-input-group .vpd-clear-btn{
  line-height: 50px;
}
</style>